// src/stores/budgetStore.js
import { defineStore } from "pinia";
import { budgetService } from "@/services/budgetService";
import { useAppStore } from "@/stores/appStore";
import { toast } from 'vue3-toastify';

export const useBudgetStore = defineStore("budgetStore", {
  state: () => ({
    budgets: [],
    budget: [],
  }),

  actions: {
    async getAllBudgets() {
      const appStore = useAppStore();
      appStore.setLoading(true);

      try {
        const response = await budgetService.fetchAllBudgets();
        this.budgets = response.data;
      } catch (error) {
        toast.error(error.response.data.message + ' - 2001');
      } finally {
        appStore.setLoading(false);
      }
    },

    async getBudget(id) {
      const appStore = useAppStore();
      appStore.setLoading(true);

      try {
        const response = await budgetService.fetchBudget(id);
        this.budget = response.data;
        return this.budget;
      } catch (error) {
        toast.error(error.response.data.message + ' - 2002');
      } finally {
        appStore.setLoading(false);
      }
    },

    async createbudget(userData) {
      const appStore = useAppStore();
      appStore.setLoading(true);

      try {
        const response = await budgetService.fetchCreateBudget(userData);
        this.budgets.push(response.data);
      } finally {
        appStore.setLoading(false);
      }
    },

    async updatebudget(id, userData) {
      const appStore = useAppStore();
      appStore.setLoading(true);

      try {
        const response = await budgetService.fetchUpdateBudget(id, userData);
        const index = this.budgets.findIndex(b => b.id === id);
        if (index !== -1) {
          this.budgets.splice(index, 1, response.data);
        }
      } finally {
        appStore.setLoading(false);
      }
    },

    async deletebudget(id) {
      const appStore = useAppStore();
      appStore.setLoading(true);

      try {
        await budgetervice.fetchDeleteBudget(id);
        this.budgets = this.budgets.filter(b => b.id !== id);
        toast.success("Success");
      } catch (error) {
        toast.error(error.response.data.message + ' - 2003');
      } finally {
        appStore.setLoading(false);
      }
    },
  },
});
